import { SettingsManager } from "@viamap/viamap2-common";
import { MitLatLng } from "src/managers/MapFacade";

export class dhmCollector {

   /**
    * Uden bygninger og træer
    */
   static terrainAt(latLng: MitLatLng | MitLatLng[]): Promise<any> {
      let wkt = "";
      if (Array.isArray(latLng)) {
         wkt = latLng.map(coord => `POINT(${coord.lng} ${coord.lat})`).join("|");
      } else {
         wkt = `POINT(${latLng.lng} ${latLng.lat})`
      }
      return fetchDHM({ "geop": wkt }) as Promise<KoteResponse<"dtm">>;
   }

   /**
    * Med bygninger og træer
    */
   static overfladeAt(latLng: MitLatLng | MitLatLng[]): Promise<any> {
      let wkt = "";
      if (Array.isArray(latLng)) {
         wkt = latLng.map(coord => `POINT(${coord.lng} ${coord.lat})`).join("|");
      } else {
         wkt = `POINT(${latLng.lng} ${latLng.lat})`
      }
      return fetchDHM({ "geop": wkt, elevationmodel: "dsm" }) as Promise<KoteResponse<"dsm">>;
   }

}

function fetchDHM(query: any): Promise<any> {
   let url = "https://services.datafordeler.dk/DHMTerraen/DHMKoter/1.0.0/GEOREST/HentKoter"
   const params = {
      username: SettingsManager.getSystemSetting("datafordelerUsername"),
      password: SettingsManager.getSystemSetting("datafordelerPassword"),
      georef: "EPSG:4326",
      ...query
   }
   return fetch(url + `?${new URLSearchParams(params)}`, {
      method: 'GET',
      headers: {
         'Accept': 'application/json'
      }
   }).then(async res => {
      if (!res.ok) {
         await res.text().then(text => {
            console.error("Error response from Mat2:", text);
         });
         throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json() as Promise<KoteResponse<"dtm" | "dsm">>;
   });
}

type KoteResponse<k extends "dtm" | "dsm"> = {
   "HentKoterRespons": {
      "georef": "EPSG:4326",
      "elevationmodel": k,
      "data":
      {
         "geop": string,
         "kote": number
      }[]
   }

}
